import React, { lazy, useEffect } from 'react'
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { themeChange } from 'theme-change'
import checkAuth from './app/auth.js';
import { useDispatch } from 'react-redux';
import { LoginUserData } from './features/user/loginSlice.js';
// import initializeApp from './app/init';
// import { GlobalLoader } from './app/auth.js';
import { baseuRL } from './app/api.js';
import axios from 'axios';

// Importing pages
const Layout = lazy(() => import('./containers/Layout.js'))
const Login = lazy(() => import('./pages/Login.js'))
const Register = lazy(() => import('./pages/Register.js'))

// Initializing different libraries
// initializeApp()


// Check for login and initialize axios
// const token = checkAuth()


function App() {

  const dispatch = useDispatch();

  const verifytoken = async (token) => {
    try {
      const response = await axios.post(
        `${baseuRL}/api/userAccount/admin/verify-token`, // Replace with your API endpoint for token verification
        { token },
      );
      dispatch(LoginUserData(response.data.user));
      return response.data;
    } catch (error) {
      console.error("Token verification failed:", error);
      return null; // If the token is invalid or any error occurs, return null
    }
  };

  

  useEffect(() => {
    themeChange(false);
    const currentTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", currentTheme); // Set the theme attribute on the root element

    const token = localStorage.getItem("packcarbazzar-token");
    if (token) {
      verifytoken(token);
    }
  }, []);
// 

  return (
    <>
      {/* <GlobalLoader /> */}
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to={"/login"} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          {/* Place new routes over this */}
          <Route path="/app/*" element={<Layout />} />
          {/* <Route path="*" element={<Navigate to={token ? "/app/dashboard" : "/login"} replace />} /> */}

        </Routes>
      </Router>
    </>
  )
}

export default App


